import { AutogenLayoutLanePreferenceTable } from "./autogen/AutogenLayoutLanePreferenceTable";
import {
    DataSourceExecutionEvent,
    Label,
    LookupModelSearchEvent, TableRowDisplayEvent, TableRowMode, TableRowModeChangeEvent, Textbox
} from "@mcleod/components";
import { LocationByTypeProps, LocationByTypeUtil } from "./LocationByTypeUtil";
import { StringUtil } from "@mcleod/core";

const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = {
    stateType: 'S',
    zoneType: 'Z',
    marketAreaType: 'M',
    useDefault: true,
    lookupProps: {
        all: {
            lookupModelAllowFreeform: true
        }
    }
}

export class LanePreferenceTable extends AutogenLayoutLanePreferenceTable {
    private _payeeId: string;

    public get payeeId(): string {
        return this._payeeId;
    }

    public set payeeId(value: string) {
        this._payeeId = value;
    }

    onLoad(): void | Promise<void> {
        this.tableLanes.rowsAreDraggable = () => false;
    }

    textboxEquipmentTypeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.applies_to = "L"; // filter for trailers only
    }

    textboxTopMatchOverrideBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active='Y';
        event.filter.parent_row_type = "P";
        event.filter.parent_row_id = this.payeeId;
        event.filter.email = ">0"

    }

    tableLanesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelLaneCount = tableRow.findComponentById("labelContactCount") as Label;
        const textboxTopMatchOverride = tableRow.findComponentById("textboxTopMatchOverride") as Textbox;
        if (labelLaneCount && textboxTopMatchOverride && this.tableLanes.quickAddRow === tableRow) {
            labelLaneCount.visible = false;
            textboxTopMatchOverride.visible = true;
        }

        // Setup dynamic lookup models based on location type
        const textboxOriginType = tableRow.findComponentById("textboxOriginType") as Textbox;
        textboxOriginType.required = false;
        const textboxDestinationType = tableRow.findComponentById("textboxDestinationType") as Textbox;
        textboxDestinationType.required = false;
        const textboxOrigin = tableRow.findComponentById("textboxOrigin") as Textbox;
        const textboxDestination = tableRow.findComponentById("textboxDestination") as Textbox;
        
        LocationByTypeUtil.setupLocationTypeChangeListenerForTableRow(textboxOriginType, textboxOrigin, LOCATION_BY_TYPE_PROPS, tableRow, this.tableLanes);
        LocationByTypeUtil.setupLocationTypeChangeListenerForTableRow(textboxDestinationType, textboxDestination, LOCATION_BY_TYPE_PROPS, tableRow, this.tableLanes);
    }

    tableLanesOnRowModeChange(event: TableRowModeChangeEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const textboxPrimaryContact = tableRow.findComponentById("textboxPrimaryContact") as Textbox;
        const labelEmail = tableRow.findComponentById("labelEmail") as Label;
        const textboxTopMatchOverride = tableRow.findComponentById("textboxTopMatchOverride") as Textbox;
        if (textboxTopMatchOverride) {
            const showTopMatchOverride = event.newMode === TableRowMode.QUICK_ADD 
                                      || event.newMode === TableRowMode.UPDATE 
                                      || !modelRow.isNull("topmatch_override");
                                      
            textboxTopMatchOverride.visible = showTopMatchOverride;
            if (labelEmail && textboxPrimaryContact) {
                textboxPrimaryContact.visible = !showTopMatchOverride && StringUtil.isEmptyString(labelEmail.text);
                labelEmail.visible = !showTopMatchOverride && !StringUtil.isEmptyString(labelEmail.text);
            }
            
        }
    }

    sourcePnnControlAfterExecution(event: DataSourceExecutionEvent) {
        const orderReplyTo = this.sourcePnnControl?.activeRow?.get("order_contact")
        const showReplyTo = orderReplyTo === 'L'; //checking if order reply to field is set to Carrier Lane
        const columnReplyTo = this.tableLanes.getColumnByCaption("Reply To Contact");
        this.tableLanes.setColumnVisibility(columnReplyTo, showReplyTo);
    }
}
